// extracted by mini-css-extract-plugin
export default {"upload-card":"AccountForm_upload-card__fPnFH","upload-preview":"AccountForm_upload-preview__mAqf-","upload-button":"AccountForm_upload-button__YnFBi"};